import React, { useEffect ,useState} from 'react';
import { NavLink, useLocation, Link } from 'react-router-dom';
import AuthService from '../services/AuthService';
import logo from '../assets/images/logo.png'; 
import Image from './Image';

const Sidebar = ({ notifications, settings }) => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const selectedUser = queryParams.get('role');
    const authUser = JSON.parse(localStorage.getItem('user'));
    const currentRole = authUser.role;
    const companyLogo = settings?.company_logo || logo;

    const logout = () => {
        if (window.confirm('Are you sure? you want to logout.')) {
            AuthService.logout();
        }
    };
    const [openDropdown, setOpenDropdown] = useState(null); 

    const toggleDropdown = (dropdownId) => {
        setOpenDropdown(openDropdown === dropdownId ? null : dropdownId); // Toggle the dropdown
    };
    
    useEffect(() => {
        initializeSidebar();

        return () => cleanupSidebar();
    });


    const initializeSidebar = () => {
        const button = document.getElementById('kt_app_sidebar_mobile_toggle');
        if (button) {
            button.addEventListener('click', toggleSidebar);
        }

        const menuLinks = document.querySelectorAll('.menu-link');
        menuLinks.forEach(link => {
            link.addEventListener('click', hideSidebar);
        });
    };

    const toggleSidebar = () => {
        const sidebar = document.getElementById('kt_app_sidebar');
        if (!sidebar) {
            return;
        }
        sidebar.style.display = (sidebar.style.display === 'block') ? 'none' : 'block';
    };

    const hideSidebar = () => {
        const sidebar = document.getElementById('kt_app_sidebar');
        if (!sidebar) {
            return;
        }
        if (window.innerWidth <= 990) {
            sidebar.style.display = 'none';
        }
    };

    const cleanupSidebar = () => {
        const button = document.getElementById('kt_app_sidebar_mobile_toggle');
        if (button) {
            button.removeEventListener('click', toggleSidebar);
        }     

        const menuLinks = document.querySelectorAll('.menu-link');
        menuLinks.forEach(link => {
            link.removeEventListener('click', hideSidebar);
        });
    };

    return (
        <div id="kt_app_sidebar" className="app-sidebar flex-column" data-kt-drawer="true" data-kt-drawer-name="app-sidebar" data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="225px" data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle">
            <div className="app-sidebar-logo px-6 bg-base" id="kt_app_sidebar_logo">
                <NavLink  to="/admin/dashboard">
                    <Image alt="Logo" src={companyLogo} className="text-center app-sidebar-logo-default" style={{ maxWidth: '300px', maxHeight: '60px' }} />
                    <Image alt="Logo" src={companyLogo} className="app-sidebar-logo-minimize" style={{ maxWidth: '120px', maxHeight: '40px' }} />
                </NavLink >
            </div>

            <div className="app-sidebar-menu overflow-hidden flex-column-fluid">
                <div id="kt_app_sidebar_menu_wrapper" className="app-sidebar-wrapper hover-scroll-overlay-y my-5" style={{maxHeight: 'calc(100vh - 120px)', overflowY: 'auto'}}>
                    <div className="menu menu-column menu-rounded menu-sub-indention px-3" id="#kt_app_sidebar_menu" data-kt-menu="true" data-kt-menu-expand="false">
                       

                        <div className="menu-item pt-5">
                            <div className="menu-content">
                                <span className="menu-heading fw-bold text-uppercase fs-7">Navigation Links</span>
                            </div>
                        </div>
                        {!['customer'].includes(currentRole) && (
                        <div className="menu-item">
                            <NavLink  to="/admin/dashboard" className="menu-link">
                                <span className="menu-icon">
                                    <span className="svg-icon svg-icon-2">
                                        <i className="fas fa-home fs-5"></i>
                                    </span>
                                </span>
                                <span className="menu-title fs-6">Dashboard</span>
                            </NavLink >
                        </div>
                        )}
                        
                        {['admin', 'staff'].includes(currentRole) && (
                            <div data-kt-menu-trigger="click" className={`menu-item menu-accordion ${openDropdown === 'customers' ? 'show' : ''}`}>
                                <span className="menu-link" onClick={() => toggleDropdown('customers')}>
                                    <span className="menu-icon">
                                        <span className="svg-icon svg-icon-2">
                                            <i className="fas fa-users fs-5"></i>
                                        </span>
                                    </span>
                                    <span className="menu-title">Customers</span>
                                    <span className="menu-arrow"></span>
                                </span>
                                <div className={`menu-sub menu-sub-accordion ${openDropdown === 'customers' ? 'show' : ''}`}>
                                    <div className="menu-item">
                                        <NavLink className="menu-link" to="/customers">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title">Customer List</span>
                                        </NavLink>
                                    </div>
                                    <div className="menu-item">
                                        <NavLink className="menu-link" to="/customers/create">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title">Register Customer</span>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        )}

                        <div className="menu-item">
                            <NavLink  to="/appointments" end className="menu-link">
                                <span className="menu-icon">
                                    <i className="fas fa-calendar-check fs-5"></i>
                                </span>
                                <span className="menu-title fs-6">{currentRole === 'customer' ? 'My Appointments' : 'Appointments'}</span>
                            </NavLink >
                        </div>

                        {['customer'].includes(currentRole) && (
                            <div className="menu-item">
                                <NavLink to="/appointments/create" className="menu-link">
                                    <span className="menu-icon">
                                        <i className="fas fa-plus-circle fs-5"></i>
                                    </span>
                                    <span className="menu-title fs-6">Book Appointment</span>
                                </NavLink>
                            </div>
                        )}

                        {['admin'].includes(currentRole) && (
                            <div className="menu-item">
                                <NavLink to="/branches" className="menu-link">
                                    <span className="menu-icon">
                                        <i className="fas fa-building fs-5"></i>
                                    </span>
                                    <span className="menu-title fs-6">Branches</span>
                                </NavLink>
                            </div>
                        )}
                        
                         {['admin'].includes(currentRole) && (
                            <div className="menu-item">
                                <NavLink to="/services" className="menu-link">
                                    <span className="menu-icon">
                                        <i className="fas fa-cut fs-5"></i>
                                    </span>
                                    <span className="menu-title fs-6">Services</span>
                                </NavLink>
                            </div>
                        )}
                        

                        {['admin'].includes(currentRole) && (
                            <div data-kt-menu-trigger="click" className={`menu-item menu-accordion ${openDropdown === 'users' ? 'show' : ''}`}>
                                <span className="menu-link" onClick={() => toggleDropdown('users')}>
                                    <span className="menu-icon">
                                        <span className="svg-icon svg-icon-2">
                                            <i className="fas fa-user-shield fs-5"></i>
                                        </span>
                                    </span>
                                    <span className="menu-title">System Users</span>
                                    <span className="menu-arrow"></span>
                                </span>
                                <div className={`menu-sub menu-sub-accordion ${openDropdown === 'users' ? 'show' : ''}`}>
                                    <div className="menu-item">
                                        <Link className={`menu-link ${selectedUser === 'admin' ? 'active' : ''}`} to="/users?role=admin">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title">Admins</span>
                                        </Link>
                                    </div>
                                    <div className="menu-item">
                                        <Link className={`menu-link ${selectedUser === 'staff' ? 'active' : ''}`} to="/users?role=staff">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title">Staff</span>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        )}

                         {['admin'].includes(currentRole) && (
                            <div data-kt-menu-trigger="click" className={`menu-item menu-accordion ${openDropdown === 'finance' ? 'show' : ''}`}>
                                <span className="menu-link" onClick={() => toggleDropdown('finance')}>
                                    <span className="menu-icon">
                                        <span className="svg-icon svg-icon-2">
                                            <i className="fas fa-file-invoice-dollar fs-5"></i>
                                        </span>
                                    </span>
                                    <span className="menu-title">Finance</span>
                                    <span className="menu-arrow"></span>
                                </span>
                                <div className={`menu-sub menu-sub-accordion ${openDropdown === 'finance' ? 'show' : ''}`}>
                                    <div className="menu-item">
                                        <NavLink className="menu-link" to="/expenses">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title">Expenses</span>
                                        </NavLink>
                                    </div>
                                    <div className="menu-item">
                                        <NavLink className="menu-link" to="/expense-categories">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title">Expense Categories</span>
                                        </NavLink>
                                    </div>
                                    <div className="menu-item">
                                        <NavLink className="menu-link" to="/transactions">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title">Transactions</span>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        )}

                         {['admin'].includes(currentRole) && (
                            <div data-kt-menu-trigger="click" className={`menu-item menu-accordion ${openDropdown === 'reports' ? 'show' : ''}`}>
                                <span className="menu-link" onClick={() => toggleDropdown('reports')}>
                                    <span className="menu-icon">
                                        <span className="svg-icon svg-icon-2">
                                            <i className="fas fa-chart-line fs-5"></i>
                                        </span>
                                    </span>
                                    <span className="menu-title">Reports</span>
                                    <span className="menu-arrow"></span>
                                </span>
                                <div className={`menu-sub menu-sub-accordion ${openDropdown === 'reports' ? 'show' : ''}`}>
                                    <div className="menu-item">
                                        <NavLink className="menu-link" to="/reports/sales">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title">Sales Report</span>
                                        </NavLink>
                                    </div>
                                    <div className="menu-item">
                                        <NavLink className="menu-link" to="/reports/expenses">
                                            <span className="menu-bullet">
                                                <span className="bullet bullet-dot"></span>
                                            </span>
                                            <span className="menu-title">Expense Report</span>
                                        </NavLink>
                                    </div>
                                </div>
                            </div>
                        )}

                        {['admin'].includes(currentRole) && (
                            <div className="menu-item">
                                <NavLink  to="/settings" className="menu-link">
                                    <span className="menu-icon">
                                        <span className="svg-icon svg-icon-2">
                                            <i className="fas fa-cog fs-5"></i>
                                        </span>
                                    </span>
                                    <span className="menu-title fs-6">Settings</span>
                                </NavLink >
                            </div>
                        )}
                        <div className="menu-item">
                            <NavLink to="/account" className="menu-link">
                                <span className="menu-icon">
                                    <i className="fas fa-user fs-5"></i>
                                </span>
                                <span className="menu-title fs-6">Account</span>
                            </NavLink>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="app-sidebar-footer flex-column-auto pt-2 pb-6 px-6" id="kt_app_sidebar_footer">
                <button 
                    onClick={logout}
                    className="btn btn-flex flex-center btn-custom btn-dark overflow-hidden text-nowrap px-0 h-40px w-100" 
                    data-bs-toggle="tooltip" 
                    data-bs-trigger="hover" 
                    data-bs-dismiss-="click" 
                    title="Logout"
                >
                    <span className="btn-label">Logout</span>
                    <span className="svg-icon btn-icon svg-icon-2 m-0">
                        <i className="fas fa-sign-out-alt"></i>
                    </span>
                </button>
            </div>
        </div>
    );
};

export default Sidebar;
